module.exports = flarum.core.compat['tags/utils/getSelectableTags'];